import {
  IconDefinition,
  IconName,
  IconPrefix,
} from '@fortawesome/fontawesome-svg-core';

/**
 * Duotone broom-wide from Font Awesome Pro 7.1.0
 * (svgs/duotone/broom-wide.svg), with the layers regrouped: the stock icon
 * fades the handle, but we want the sweeping head separately styleable. The
 * head renders as `.fa-secondary` and the handle + collar as `.fa-primary`,
 * so they can be colored independently via `--fa-secondary-color` /
 * `--fa-primary-color`.
 */
export const faBroomWideDuotone: IconDefinition = {
  prefix: 'fac' as IconPrefix,
  iconName: 'broom-wide-duotone' as IconName,
  icon: [
    576,
    512,
    [],
    '',
    [
      'M187.5 183.8L16.4 278.9C6.3 284.5 0 295.2 0 306.8 0 315.2 3.4 323.4 9.3 329.3l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 534.7c6 6 14.1 9.3 22.6 9.3 11.6 0 22.3-6.3 27.9-16.4l95.1-171.1-172.7-172.7z',
      'M329.4 169.4c15.1 15.1 30.2 30.2 45.3 45.3l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zM313.6 153.6c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18 156.5 156.5 18-32.5c10.4-18.7 7.1-42.1-8-57.3l-76.8-76.8z',
    ],
  ],
};
